import { hostedAuthApplicationDomain, hostedAuthDomain } from '@unipile/db';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';

export const HostedAuthDomainSchema = createSelectSchema(hostedAuthDomain);
export const InsertHostedAuthDomainSchema = createInsertSchema(hostedAuthDomain);

export const HostedAuthApplicationDomainSchema = createSelectSchema(hostedAuthApplicationDomain);
export const InsertHostedAuthApplicationDomainSchema = createInsertSchema(hostedAuthApplicationDomain);

export type HostedAuthDomain = typeof hostedAuthDomain.$inferSelect;
export type InsertHostedAuthDomain = typeof hostedAuthDomain.$inferInsert;
export type HostedAuthApplicationDomain = typeof hostedAuthApplicationDomain.$inferSelect;
export type InsertHostedAuthApplicationDomain = typeof hostedAuthApplicationDomain.$inferInsert;
